import {Heading} from 'components/template/Heading'
import {List} from './List'
import OrderHistoryTable from './OrderHistory'
import {useEffect, useState} from 'react'
import {PaginatedResult} from 'rest/types/PaginatedResult'
import {CouponCenterTransaction} from 'rest/types/CouponCenterTransaction'
import {PaymentService} from 'rest'
import {Spinner} from 'components/template/Spinner'
import MerchantStatus from 'components/MerchantStatus'

const initialState = {
  count: 0,
  next: null,
  previous: null,
  results: [],
}

export const Payment = () => {
  const [results, setResults] =
    useState<PaginatedResult<CouponCenterTransaction>>(initialState)

  const [loading, setLoading] = useState(false)

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await PaymentService.getTransactions()

      setResults(response)
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const transactionDate = new Date(
    results.results[0]?.transaction_created * 1000
  )
  transactionDate.setMonth(transactionDate.getMonth() + 1) // Add one month

  return (
    <div>
      <Heading title="PAYMENT" />
      {results?.count > 0 && <MerchantStatus loading={loading} />}
      <h1 className="py-4 text-xl font-semibold leading-8 tracking-tight">
        PAYMENT DETAILS
      </h1>
      <div
        className="flex bg-[url('assets/mascot.svg')] bg-no-repeat
       bg-[right_6rem_top_2rem] flex-col ">
        {/* <OrderDetails /> */}

        <List />

        {loading ? (
          <div className="w-120 h-120 items-center flex my-16">
            <Spinner />{' '}
          </div>
        ) : (
          <OrderHistoryTable results={results} />
        )}

        {/* <Add /> */}
      </div>
    </div>
  )
}
